import AccordionItemHandler from 'components/forms/new/AccordionItemHandler';

import PrimaryContactName from '../formFields/PrimaryContactName';
import PrimaryContactPhone from '../formFields/PrimaryContactPhone';
import PrimaryContactEmail from '../formFields/PrimaryContactEmail';
import AccountsContactEmail from '../formFields/AccountsContactEmail';
import SupportContactEmail from '../formFields/SupportContactEmail';

const CompanyGeneralContact = ({ errors, touched, darkMode }) => {
    const formFields = (errors, touched) => {
        const fields = [
            <PrimaryContactName
                key="primaryContactName"
                errors={errors}
                touched={touched}
                darkMode={darkMode}
            />,
            <PrimaryContactPhone
                key="primaryContactPhone"
                errors={errors}
                touched={touched}
                darkMode={darkMode}
            />,
            <PrimaryContactEmail
                key="primaryContactEmail"
                errors={errors}
                touched={touched}
                darkMode={darkMode}
            />,
            <AccountsContactEmail
                key="accountsContactEmail"
                errors={errors}
                touched={touched}
                darkMode={darkMode}
            />,
            <SupportContactEmail
                key="supportContactEmail"
                errors={errors}
                touched={touched}
                darkMode={darkMode}
            />,
        ];

        return fields;
    };

    // Filter out null/false values from conditional fields
    const filteredFields = formFields(errors, touched).filter(Boolean);

    return (
        <AccordionItemHandler
            index={2}
            key="companyGeneralContact"
            label="Contact Information"
            errors={errors}
            touched={touched}
            defaultIsOpen={true}>
            {filteredFields}
        </AccordionItemHandler>
    );
};

export default CompanyGeneralContact;
